import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <span className="footer__brand-mark">Salkara Inn</span>
          <p className="footer__tagline">
            A cinematic five-star stay in the heart of Palakkad — where quiet luxury meets warm Kerala hospitality.
          </p>
          <div className="footer__social">
            {/* <a href="https://www.facebook.com/share/1KJPVvmpTj/" target="_blank" rel="noreferrer" aria-label="Facebook"><FiFacebook /></a> */}
            <a href="https://www.instagram.com/salkarainn?igsh=Y3dxanRkejlheHJy" target="_blank" rel="noreferrer" aria-label="Instagram"><FiInstagram /></a>
            {/* <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter"><FiTwitter /></a> */}
            {/* <a href="https://wa.me/919886666844" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a> */}
          </div>
        </div>

        <div className="footer__col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/rooms">Rooms &amp; Suites</Link></li>
            <li><Link to="/services">Amenities</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4>Gallery</h4>
          <Link to="/gallery">
          <div className="footer__gallery-preview">
            {[
              'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=200&q=80',
              'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=200&q=80',
              'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=200&q=80',
              'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=200&q=80',
              'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=200&q=80',
              'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=200&q=80',
            ].map((src, i) => (
              <img key={i} src={src} alt="" loading="lazy" />
            ))}
          </div>
          </Link>
        </div>

        <div className="footer__col">
          <h4>Contact</h4>
          <ul className="footer__contact">
            <li>Toll Plaza, Pudussery, Near Attappallam, Palakkad - Coimbatore Road, Attapallam, Palakkad-678621, Kerala</li>
            {/* <li><a href="tel:+919999999999">+91 99999 99999</a></li> */}
            <li><a href="mailto:salkarainn91@gmail.com">salkarainn91@gmail.com</a></li>
          </ul>
          <form className="footer__newsletter" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="Your email" aria-label="Email for newsletter" required />
            <button type="submit" className="btn btn-gold">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer__bottom container">
        <span>&copy; {year} Salkara Inn, Palakkad. All rights reserved.</span>
        <span className="footer__credit">Crafted for an unforgettable stay.</span>
        <span className="footer__credit">Developed by <a style={{fontWeight:'bold'}} href='https://mpeoples.in/' target='_blank'> Mpeoples Business Solutions Pvt Ltd </a></span>
      </div>
    </footer>
  );
}